import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { MethodPreference } from '@thiememeulenhoff/types';

export const methodPreferences = createStore(
  { name: 'methodPreferences' },
  withEntities<MethodPreference, 'method'>({
    idKey: 'method',
  }),
);
